<template>
    <img :src="chestImage" alt="" />
</template>

<script>
export default {
    name: 'TreasureChest',
    props: {
        type: {
            type: String,
            default: 'default',
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        chestImage() {
            if (this.type === 'special' || this.type === 'catch_up') {
                return this.isOpen
                    ? '/img/gamification/chest_types/chest_special_open.svg'
                    : '/img/gamification/chest_types/chest_special_closed.svg';
            }

            if (this.type === 'basic') {
                return this.isOpen
                    ? '/img/gamification/chest_types/chest_basic_open.svg'
                    : '/img/gamification/chest_types/chest_basic_closed.svg';
            }

            return this.isOpen
                ? '/img/gamification/chest_types/chest_default_open.svg'
                : '/img/gamification/chest_types/chest_default_closed.svg';
        },
    },
};
</script>
